import { useMemo } from 'react'
import { getLatestOpenTime } from 'lib/businessHour'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { OpenTimeType } from 'types/store'
import { StoreCalendarType } from 'types/storeCalendar'

const useLatestOpenTime = (
  daysOfWeek: DayOfWeekType[],
  openTime: OpenTimeType,
  temporaryOpen?: StoreCalendarType
): string => {
  return useMemo(() => {
    // 臨時営業日であれば臨時営業日の店舗オープン時刻を返す
    if (temporaryOpen && temporaryOpen.open_time) {
      return temporaryOpen.open_time
    } else {
      return getLatestOpenTime(daysOfWeek, openTime)
    }
  }, [daysOfWeek, openTime, temporaryOpen])
}

export default useLatestOpenTime
